(() => {
    frappe.ready(() => {
        const Orig = webshop.ProductGrid;
        if (!Orig) return;

        class ProductGridPatched extends Orig {
            // Revert: stock availability only (no bulk prices — they move to
            // the bottom row for the compact side-by-side layout, adj3).
            get_stock_availability(item, settings) {
                return Orig.prototype.get_stock_availability.call(this, item, settings) || "";
            }

            // Skip the separate price rendering — price + bulk prices move
            // into the bottom row (adj3: cart left, prices right, same level).
            get_card_body_html(item, title, settings) {
                let body_html = `
                    <div class="card-body text-left card-body-flex" style="width:100%">
                        <div style="margin-top: 0; display: flex;">
                `;
                body_html += `<div class="flex-1 min-width-0">`;
                if (settings.custom_show_item_code) {
                    body_html += `<div class="product-code-plain">${ item.item_code || '' }</div>`;
                }
                body_html += this.get_title(item, title);
                body_html += `</div></div>`;

                if (settings.custom_show_item_group) {
                    body_html += `<div class="product-category" itemprop="name">${ item.item_group_display || item.item_group || '' }</div>`;
                }

                // Price + bulk prices are now in the bottom row (adj3)
                body_html += this.get_stock_availability(item, settings);

                // Simple UOM view (PIT-TASK-2027-000285): conversion factors
                // "32/768/1536" of the UOMs configured in Webshop Settings.
                if (settings.show_simple_uom_view && item.simple_uom_view) {
                    body_html += `<div class="ws-simple-uom">${ item.simple_uom_view }</div>`;
                }

                body_html += this.get_bottom_row_html(item, settings);
                body_html += `</div>`;
                return body_html;
            }

            // Bottom row: cart controls (left) + price section (right) + desc
            get_bottom_row_html(item, settings) {
                const cart_row = this.get_cart_action_row(item, settings);
                const desc = item.short_description
                    ? `<div class="ws-short-desc">${ item.short_description }</div>` : ``;

                // Standard price
                let price_html = '';
                if (item.formatted_price) {
                    price_html = `<div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">`;
                    price_html += item.formatted_price || '';
                    if (item.formatted_mrp) {
                        price_html += `<small class="striked-price"><s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s></small>`;
                    }
                    price_html += `</div>`;
                }

                // Bulk prices
                const bulk_html = item.bulk_prices_html || '';
                const bulk_wrapper = bulk_html ? `<div class="bulk-prices-wrapper">${ bulk_html }</div>` : '';

                const price_section = (price_html || bulk_wrapper)
                    ? `<div class="ws-bottom-prices">${ price_html }${ bulk_wrapper }</div>` : '';

                if (!desc && !cart_row && !price_section) return ``;
                return `<div class="ws-bottom-row">${ cart_row }${ price_section }${ desc }</div>`;
            }
        }
        webshop.ProductGrid = ProductGridPatched;
    });
})();
